import classnames from 'classnames';
import React from 'react';

type FormToggleProps = React.InputHTMLAttributes<HTMLInputElement> & { label?: string };
const FormToggle: React.FC<FormToggleProps> = React.memo(({ label, id, ...inputProps }) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input type="checkbox" className="sr-only peer" {...inputProps} />
      <div
        className={classnames(
          'w-[50px] h-[22px]',
          'bg-pureWhite/30 rounded-full peer peer-focus:ring-1 peer-focus:ring-blueElectric-300 dark:peer-focus:ring-blueElectric-800 dark:bg-gray-700',
          "peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full",
          'after:h-[20px] after:w-[20px] after:top-[1px]',
          'after:transition-all dark:border-gray-600 peer-checked:bg-blueElectric',
          {
            'after:start-[0px]': !inputProps.checked,
            'after:start-[10px]': inputProps.checked,
          },
        )}
      ></div>
    </label>
  );
});
FormToggle.displayName = 'FormToggle';
export default FormToggle;
